import { isEmpty } from "lodash";
import { toQueryString } from "./toQueryString";

type Params = Record<string, any>;

export const appendQueryString = (path: string, params: Params = {}) =>
  !isEmpty(params) ? `${path}?${toQueryString(params)}` : path;
